var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('PageTitle', [_vm._v("請綁定 POYA Pay 會員")]), _c('Form', {
    attrs: {
      "action": _vm.submit,
      "after-action": _vm.afterSubmit
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var busy = _ref.busy;
        return [_c('div', {
          staticClass: "s-space-y-3 s-mb-10"
        }, [_c('div', {
          staticClass: "s-flex s-items-center s-space-x-2"
        }, [_c('Input', {
          staticClass: "s-flex-1",
          attrs: {
            "label": "手機號碼",
            "type": "text",
            "inputmode": "tel",
            "name": "mobileNumber",
            "placeholder": "0987654321",
            "pattern": "\\d*",
            "maxlength": "10",
            "required": ""
          },
          model: {
            value: _vm.mobileNumber,
            callback: function callback($$v) {
              _vm.mobileNumber = $$v;
            },
            expression: "mobileNumber"
          }
        }), _c('SendVerifyCode', {
          attrs: {
            "mobile-number": _vm.mobileNumber,
            "mobild-number-is-valid": _vm.mobildNumberIsValid
          }
        })], 1), _c('Input', {
          attrs: {
            "label": "簡訊驗證碼",
            "type": "text",
            "inputmode": "numeric",
            "name": "verifyCode",
            "placeholder": "123456",
            "pattern": "\\d*",
            "maxlength": "6",
            "required": ""
          },
          model: {
            value: _vm.verifyCode,
            callback: function callback($$v) {
              _vm.verifyCode = $$v;
            },
            expression: "verifyCode"
          }
        })], 1), _c('button', {
          staticClass: "s-btn s-btn-primary",
          attrs: {
            "type": "submit",
            "disabled": !_vm.formIsValid || busy
          }
        }, [_vm._v(" 下一步 ")])];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }